import React from "react";

function UserAccountFormTable({children}) {
    return (
        <table className="user-account-edit-form__table">
            <colgroup>
                <col className="user-account-edit-form__col-label" />
                <col className="user-account-edit-form__col-value" />
                <col className="user-account-edit-form__col-label" />
                <col className="user-account-edit-form__col-value" />
            </colgroup>
            {children}
        </table>
    );
}

export default UserAccountFormTable;
